import {useEffect,useState} from 'react'
import { useNavigate } from 'react-router-dom'
import MovieRow from './MovieRow'
import {useSelector,useDispatch} from "react-redux"
import {fetchMovie} from "../store/actions"

function Table(){
    const dispatch= useDispatch()
    const {movies}= useSelector((state)=>state.movie)
    const [loading,setLoading]= useState(true)
    const [search,setSearch]= useState("")
    const [movieSearch,setMovieSearch]= useState([])
    const navigate = useNavigate()

    
    useEffect(()=>{
       
        if(search){
            const newMovie= movies.filter((el)=> el.title == search)
            setMovieSearch(newMovie)
        }else{
            setMovieSearch(movies)
        }

    },[movies,search])

   useEffect(()=>{
    dispatch(fetchMovie())
    .finally(()=>{
        setLoading(false)
    })
   },[])

    const toCreate= ()=>{
        navigate('/add')
    }
// const {loading}= useSelector((state)=>state)
   

return(
<div>
<div className="flex flex-col pl-72 justify-end pr-5 pt-10">
    <div className=''>
        <h1 style={{fontSize: "40pt"}}>Movie List</h1>
    </div>
<input type="text" name="search" value={search} onChange={(e)=>setSearch(e.target.value)} placeholder='Search' style={{width: "1000px"}} className='border-b-2 border-blue-300 focus:outline-none'/>
<div className="flex pt-5" style={{paddingLeft: "800px"}}>
    <button className='bg-green-400 rounded-lg' style={{width: "200px", height: "40px"}} onClick={()=>{toCreate()}}>Create Movie</button>
</div>
    <div className="flex pr-10 pt-5 pb-10">
    <div className="overflow-x-auto relative shadow-md sm:rounded-lg" style={{width:"1100px"}}>
    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" className="py-3 px-6">
                    No.
                </th>
                <th scope="col" className="py-3 px-6">
                    Title
                </th>
                <th scope="col" className="py-3 px-6">
                    Slug
                </th>
                <th scope="col" className="py-3 px-6">
                    Synopsis
                </th>
                <th scope="col" className="py-3 px-6">
                    Rating
                </th>
                <th scope="col" className="py-3 px-6">
                    Genre
                </th>
                <th scope="col" className="py-3 px-6">
                    Image
                </th>
                <th scope="col" className="py-3 px-6">
                    Detail
                </th>
                <th scope="col" className="py-3 px-6">
                    Action
                </th>
            </tr>
        </thead>
        <tbody>
            {loading ? (<lottie-player src="https://assets6.lottiefiles.com/packages/lf20_qWnsM1rE89.json"  background="transparent"  speed="1"  style={{width: "500px" , height: "400px"}}  loop autoplay></lottie-player>): (movieSearch.map((movie,i)=>
                <MovieRow  key={movie.id} movie={movie} i={i}/>)
            )}
        </tbody>
    </table>
</div>
    </div>
</div>
</div>
)
}

export default Table